import React from "react";
import { ExternalLink } from "lucide-react";

const FIREWORKS = "https://customer-assets.emergentagent.com/job_vela-autentica/artifacts/jghs7yj9_IMG-20240809-WA0006.jpg";

const refs = [
  {
    source: "La Voz de Galicia",
    title: "El antiguo barco de Greenpeace que se estrena en el cine de Carla Simón",
    year: "2025",
    url: "https://www.lavozdegalicia.es/noticia/vigo/2025/08/27/antiguo-barco-greenpeace-estrena-cine-carla-simon/0003_202508V27C5991.htm",
  },
  {
    source: "La Voz de Galicia",
    title: "Vigo en «Romería», un plató de cine infinito",
    year: "2025",
    url: "https://www.lavozdegalicia.es/noticia/vigo/2025/08/28/vigo-romeria-plato-cine-infinito/0003_202508V28C3991.htm",
  },
  {
    source: "La Voz de Galicia",
    title: "Repara un viejo barco de Greenpeace en Portonovo para recorrer mundo",
    year: "2015",
    url: "https://www.lavozdegalicia.es/noticia/pontevedra/2015/07/29/repara-viejo-barco-greenpeace-portonovo-recorrer-mundo/0003_201507P29C7991.htm",
  },
  {
    source: "Roge Blasco",
    title: "Maite Mompó, historias de los barcos de Greenpeace",
    year: "2014",
    url: "https://rogeblasco.blog/2014/11/03/maite-mompo-historias-de-los-barcos-de-greenpeace/",
  },
];

export default function Prensa() {
  return (
    <section id="prensa" className="relative bg-navy text-white overflow-hidden" data-testid="prensa-section">
      {/* Hero image with overlay */}
      <div className="relative h-[44vh] min-h-[300px] md:h-[55vh] w-full">
        <img src={FIREWORKS} alt="El Zorba navegando a vela" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/40 via-navy/55 to-navy" />
        <div className="relative z-10 h-full container-tight flex flex-col justify-end pb-12 md:pb-16">
          <p className="label-eyebrow text-sand mb-4">Prensa y referencias</p>
          <h2 className="font-heading text-4xl md:text-5xl leading-[1.05] max-w-3xl" data-testid="prensa-title">
            Zorba en prensa y referencias.
          </h2>
        </div>
      </div>

      <div className="container-tight pb-20 md:pb-24 -mt-2">
        <p className="max-w-3xl text-white/80 text-base md:text-lg leading-relaxed mb-12">
          La historia del Zorba también ha sido recogida en prensa y medios por su etapa como antiguo velero de Greenpeace, su restauración en Portonovo y su participación en producciones audiovisuales como <em>Romería</em>, de Carla Simón.
        </p>

        <ul className="grid md:grid-cols-2 gap-3 md:gap-4">
          {refs.map((r, i) => (
            <li key={r.url}>
              <a
                href={r.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`prensa-link-${i}`}
                className="group flex items-start justify-between gap-4 p-5 md:p-6 rounded-md border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] hover:border-sand/40 transition-all"
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="label-eyebrow text-sand">{r.source}</span>
                    <span className="text-white/40 text-xs">· {r.year}</span>
                  </div>
                  <p className="font-heading text-lg md:text-xl text-white leading-snug group-hover:text-sand transition-colors">
                    {r.title}
                  </p>
                </div>
                <ExternalLink size={18} className="text-white/50 group-hover:text-sand transition-colors flex-shrink-0 mt-1.5" strokeWidth={1.5} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
